import type { Color } from '@ui/types/base/color'
import type { Variant } from '@ui/types/base/variant'

type ExtendedColor = Color | 'green'
type ExtendedVariant = Variant | 'text' | 'plain'

const textVariantMap: Record<ExtendedVariant, Record<ExtendedColor, string>> = {
  default: {
    default: 'text-default',
    primary: 'text-white',
    secondary: 'text-white',
    accent: 'text-accent-contrast',
    success: 'text-white',
    warning: 'text-default',
    danger: 'text-white',
    info: 'text-white',
    white: 'text-default',
    light: 'text-default',
    dark: 'text-white',
    green: 'text-white'
  },
  outlined: {
    default: 'text-default',
    primary: 'text-primary',
    secondary: 'text-secondary',
    accent: 'text-accent',
    success: 'text-success',
    warning: 'text-default',
    danger: 'text-danger',
    info: 'text-info',
    white: 'text-default',
    light: 'text-default',
    dark: 'text-default',
    green: 'text-pink'
  },
  tonal: {
    default: 'text-default',
    primary: 'text-primary',
    secondary: 'text-default',
    accent: 'text-accent',
    success: 'text-success',
    warning: 'text-default',
    danger: 'text-danger',
    info: 'text-info',
    white: 'text-default',
    light: 'text-default',
    dark: 'text-default',
    green: 'text-pink'
  },
  text: {
    default: 'text-default',
    primary: 'text-primary',
    secondary: 'text-default',
    accent: 'text-accent',
    success: 'text-success',
    warning: 'text-warning',
    danger: 'text-danger',
    info: 'text-info',
    white: 'text-white',
    light: 'text-default',
    dark: 'text-white',
    green: 'text-pink'
  },
  plain: {
    default: 'text-default',
    primary: 'text-primary',
    secondary: 'text-default',
    accent: 'text-accent',
    success: 'text-success',
    warning: 'text-warning',
    danger: 'text-danger',
    info: 'text-info',
    white: 'text-white',
    light: 'text-default',
    dark: 'text-white',
    green: 'text-pink'
  }
}

export const useTextVariant = (variant: ExtendedVariant, color: ExtendedColor) => textVariantMap[variant][color]
